import { Socket } from 'socket.io-client';
import { Action } from 'types/actions';

const socketEmits = <T extends object>(socket: Socket, dispatch: React.Dispatch<Action>, payload: T) => {
  socket.emit('scheduleList', JSON.stringify(payload));
  dispatch({ type: 'UPDATE_BID_WATCH_LIST', payload: payload });
};

export default socketEmits;
